import React, { useContext } from 'react';
import { string, shape, bool, number } from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { CategoryCardsDesktop } from './CategoryCardsDesktop';
import { CategoryCardsMobile } from './mobile/CategoryCardsMobile';
import { dataModel } from './dataModel';

const CategoryCards = ({
  keyword,
  navParam,
  storeId,
  data,
  loading,
  error,
  ssr
}) => {
  const { channel } = useContext(ExperienceContext);

  return channel === 'mobile' ? (
    <CategoryCardsMobile
      keyword={keyword}
      navParam={navParam}
      storeId={storeId}
      data={data}
      loading={loading}
      error={error}
      ssr={ssr}
    />
  ) : (
    <CategoryCardsDesktop
      keyword={keyword}
      navParam={navParam}
      storeId={storeId}
      data={data}
      loading={loading}
      error={error}
      ssr={ssr}
    />
  );
};

CategoryCards.displayName = 'CategoryCards';

CategoryCards.dataModel = dataModel;

CategoryCards.propTypes = {
  keyword: string,
  navParam: string,
  data: shape({}),
  loading: bool,
  error: shape({}),
  ssr: bool,
  storeId: string
};

CategoryCards.defaultProps = {
  keyword: null,
  navParam: null,
  data: undefined,
  loading: undefined,
  error: undefined,
  ssr: false,
  storeId: undefined
};

export { CategoryCards };
